module.exports = __webpack_public_path__ + "static/media/14UNEP2.938f2b0d.jpg";